import React, { useState, useEffect } from 'react';
import '../dashboard/Dashboard.css'; // Import the CSS file for styles
import '@fortawesome/fontawesome-free/css/all.min.css';

interface CampaignData {
  startDate: string;
  endDate: string;
  total: number;
  adRequests: number;
  visits: number;
  cost: string;
  cpc: string;
  campaign_name: string; // Add this property
}

const ErrorLogPage: React.FC = () => {
  const [data, setData] = useState<CampaignData[] | null>(null);
  const [campaignNames, setCampaignNames] = useState<string[]>([]);
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState<boolean>(false);
  const [selectedCampaign, setSelectedCampaign] = useState<string>('All Ads');

  const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL;

  const fetchCampaignNames = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/campiagns/campaignNames`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setCampaignNames(data.campaignNames);
    } catch (error) {
      console.error('Error fetching campaign names:', error);
    }
  };

  useEffect(() => {
    fetchCampaignNames();
  }, []);

  const fetchData = async () => {
    if (!startDate || !endDate) {
      alert('Please select both start and end dates.');
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/api/summary/getData?startDate=${startDate}&endDate=${endDate}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result: CampaignData[] = await response.json();
      if (result.length === 0) {
        setNoData(true);
      } else {
        setNoData(false);
        setData(result);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  const handleCampaignFilterChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedCampaign(event.target.value);
  };

  const filteredData = selectedCampaign === 'All Ads'
    ? data
    : data?.filter((item) => item.campaign_name === selectedCampaign) || null;

  const calculateDateRange = (option: string) => {
    const today = new Date();
    let start: Date;
    let end: Date;

    switch (option) {
      case 'Today':
        start = new Date(today);
        end = new Date(today);
        break;
      case 'Yesterday':
        start = new Date(today);
        start.setDate(today.getDate() - 1);
        end = new Date(today);
        end.setDate(today.getDate() - 1);
        break;
      case 'Last 7 days':
        start = new Date(today);
        start.setDate(today.getDate() - 6);
        end = new Date(today);
        break;
      case 'This Month':
        start = new Date(today.getFullYear(), today.getMonth(), 1);
        end = new Date(today);
        break;
      case 'Last Month':
        start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        end = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      default:
        return;
    }

    setStartDate(start.toISOString().split('T')[0]);
    setEndDate(end.toISOString().split('T')[0]);
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
        <div style={{display:'grid', marginTop:'-20px'}}>
        <label htmlFor="date-range" style={{ fontWeight: 'bold', fontSize:'12px' }}>Date Range:</label>
        <select
          id="date-range"
          onChange={(e) => calculateDateRange(e.target.value)}
          style={{ padding: '5px', border: '1px solid #ccc', borderRadius: '4px' }}
           className="date-picker"
        >
          <option value="Today">Today</option>
          <option value="Yesterday">Yesterday</option>
          <option value="Last 7 days">Last 7 days</option>
          <option value="This Month">This Month</option>
          <option value="Last Month">Last Month</option>
        </select>
        </div>
        
        <input
          type="date"
          value={startDate}
           className="date-picker"
          onChange={(e) => setStartDate(e.target.value)}
          style={{ padding: '5px', border: '1px solid #ccc'}}
        />
        <input
          type="date"
           className="date-picker"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          style={{ padding: '5px', border: '1px solid #ccc'}}
        />
      
        <button
          onClick={fetchData}

          className="btn btn-generate"
          style={{ padding: '6px 12px', backgroundColor: '#28a745', color: '#fff', cursor: 'pointer' }}
        >
          Generate
        </button>
      </div>

      {loading ? (
        <div>Loading...</div>
      ) : noData ? (
        <div className="no-data-message">No data available for the selected date range.</div>
      ) : (
        <div className='campaign-table' style={{ backgroundColor: '#fff', padding: '20px', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', maxWidth: '100%', margin: 'auto' }}>
        <p>No activity logged during the chosen time frame</p>
        </div>
      )}
    </div>
  );
};

export default ErrorLogPage;
